import ApiConstant from "../../constants/api.constants";
import { BullsOperatorsResponse, MUPlantResponse, OilSeedResponse, SeedOilData, VendorResponse } from "../../models/oilProduction-model";

import api from "../api";
 
 interface SeedOilResponseDTO {
   SeedData: SeedOilData[];
   ConstantProductionCount: number;
 }
const GetMUPlantName = async () => {  
    try {
        const vendor: any = await api
        .get(ApiConstant.GetMUPlantName)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;        
         })
         .catch(function (error: any) {
             console.error('error reading get vendor details', error);
         });
        const response = vendor != null ? vendor : null;        
        return response;
    }
    catch (e) {
        console.log('error in vendor details');
        return [];
    }
};
 const GetMUPlantName1 = async () => {  
    try {
        const vendor: any = await api
        .get(ApiConstant.GetMUPlantName1)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;        
         })
         .catch(function (error: any) {
             console.error('error reading get vendor details', error);
         });
        const response = vendor != null ? vendor : null;        
        return response;
    }
    catch (e) {
        console.log('error in vendor details');
        return [];
    }
};


const GetMUPlantNameById = async (posId: number): Promise<MUPlantResponse | null> => {
  try {
    const response = await api.get(`${ApiConstant.GetMUPlantNameById}?posId=${posId}`);
    return response?.data ?? null; 
  } catch (e) {
    console.error("Error in GetMUPlantNameById:", e);
    return null;
  }
};

const getAllOilIntakeLogs = async () => {
  try {
    const response = await api.get(ApiConstant.getAllOilIntakeLogs);
    return response.data || []; 
  } catch (error) {
    console.error("Error fetching oil intake logs:", error);
    throw error;
  } 
};

export const getAllOilIntakeLog = async (filter: {
  keywordSearch?: string | null;
  oilSeedID?: number | null;
  posID?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  pageNumber?: number;
  pageSize?: number;
}) => {
  try {
    const response = await api.post(ApiConstant.getAllOilIntakeLog, filter);
    return {
      data: response.data?.data || [],
      totalRecords: response.data?.totalRecords || 0,
    };
  } catch (error) {
    console.error("Error fetching oil intake logs:", error);
    throw error;
  }
};

export const exportOilIntakeLogs = async (filter: {
  keywordSearch?: string | null;
  oilSeedID?: number | null;
  posID?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  sortColumn?: string | null;
  sortDirection?: string | null;
}) => {
  try {
    const response = await api.post(ApiConstant.GetoilproductionrecordExport, filter);

    return response.data || [];
  } catch (error) {
    console.error("Error exporting oil intake logs:", error);
    throw error;
  }
};


 const getAllOilIntakeLogs1 = async () => {
  debugger
  try {
    const response = await api.get(ApiConstant.getstage2AllOilIntakeLogs);
    return response.data || []; 
  } catch (error) {
    console.error("Error fetching oil intake logs:", error);
    throw error;
  }
};

// const getOilSeedNames = async (posId: number): Promise<OilSeedResponse[]> => {
//   try {
//     const response = await api.get(`${ApiConstant.getOilSeedNames}?posId=${posId}`);
//     return response?.data ?? [];
//   } catch (e) {
//     console.error("Error in getOilSeedNames:", e);
//     return [];
//   }
// };

// service/oilProductionService.ts

const getOilSeedNames = async (
  posId: number,
  excludeOilIntakeLogId?: number
): Promise<OilSeedResponse[]> => {
  try {
    const url = excludeOilIntakeLogId
      // ? `${ApiConstant.getOilSeedNames}?posId=${posId}&excludeOilIntakeLogId=${excludeOilIntakeLogId}`
      // : `${ApiConstant.getOilSeedNames}?posId=${posId}`;
  ? `${ApiConstant.getOilSeedNames}/${posId}?excludeOilIntakeLogId=${excludeOilIntakeLogId}`
  : `${ApiConstant.getOilSeedNames}/${posId}`;

    const response = await api.get(url);
    return response?.data ?? [];
  } catch (e) {
    console.error("Error in getOilSeedNames:", e);
    return [];
  }
};

const getVendorsByOilseed = async (
  rawMaterialId: number,
  posId?: number,
  excludeOilIntakeLogId?: number
): Promise<VendorResponse[]> => {
  try {
    if (!posId) throw new Error("posId is required");

    const query = excludeOilIntakeLogId
      ? `?excludeOilIntakeLogId=${excludeOilIntakeLogId}`
      : "";

    const url = `${ApiConstant.getVendorNames}/${rawMaterialId}/${posId}${query}`;

    const response = await api.get(url);
    return response?.data ?? [];
  } catch (e) {
    console.error("Error in getVendorsByOilseed:", e);
    return [];
  }
};


const getAllOilSeedNames = async () => {
  try {
        const response = await api.get(ApiConstant.getAllOilSeedNames);
        console.log("API Raw Response:", response);
    console.log("API Response Data:", response.data);
    return response?.data ?? [];
  } catch (e) {
    console.error("Error in getOilSeedNames:", e);
    return [];
  }
};

 const getSeedOilByMonth = async (month: string, posIds: number[] = []) => {
  try {
    const posIdsParam = posIds.join(",");
    const response = await api.get(`${ApiConstant.getSeedOilSummaryReport}?month=${month}&posIds=${posIdsParam}`);
    return response?.data ?? [];
  } catch (e) {
    console.error("Error in getSeedOilByMonth:", e);
    return [];
  }
};

// const getSeedOilByMonth = async (month: string): Promise<SeedOilResponseDTO> => {
//   try {
//     const response = await api.get(`${ApiConstant.getSeedOilSummaryReport}?month=${month}`);
//     const data = response?.data ?? {};

//     return {
//       SeedData: data.seedData ?? [],
//       ConstantProductionCount: data.constantProductionCount ?? 0
//     };
//   } catch (e) {
//     console.error("Error in getSeedOilByMonth:", e);
//     return { SeedData: [], ConstantProductionCount: 0 };
//   }
// };



//  const getVendorsByOilseed = async (rawMaterialId: number, posId?: number): Promise<VendorResponse[]> => {
//   try {
// const response = await api.get(
//       `${ApiConstant.getVendorNames}?rawMaterialId=${rawMaterialId}&posId=${posId}`
//     );
//     return response?.data ?? [];
//   } catch (e) {
//     console.error("Error in getVendorsByOilseed:", e);
//     return [];
//   }
// };

export const getBullsAndOperators = async (
  posId: number
): Promise<BullsOperatorsResponse | null> => {
  try {
    const { data } = await api.get<BullsOperatorsResponse>(
      `${ApiConstant.getBullsAndOperatorsByPosId}?posId=${posId}`
    );
    return data ?? null;
  } catch (e) {
    console.error("Error in getBullsAndOperators:", e);
    return null;
  }
};

const addOilIntakeLog = async (payload: any): Promise<any> => {
  try {
    
    const response = await api.post(ApiConstant.addOilIntakeLog, payload);
   
 return response?.data;
  } catch (e) {
    console.error("Error in addOilIntakeLog:", e);
    throw e; 
  }
};

const editOilIntakeLog = async (payload: any): Promise<any> => {
  try {
    
    const response = await api.post(ApiConstant.editOilIntakeLogAPI, payload);
   
 return response?.data;
  } catch (e) {
    console.error("Error in editOilIntakeLog:", e);
    throw e; 
  }
};



const updateOilIntakeLog = async (id: number, payload: any): Promise<any> => {
  try {
    const response = await api.put(`${ApiConstant.updateOilIntakeLog}/${id}`, payload);
    return response?.data;
  } catch (e) {
    console.error("Error in addOilIntakeLog:", e);
    throw e; 
  }
};

const updateOilIntakeLog1 = async (id: number, payload: any): Promise<any> => {
  try {
    const response = await api.put(`${ApiConstant.updateOilIntakeLog1}/${id}`, payload);
    return response?.data;
  } catch (e) {
    console.error("Error in addOilIntakeLog:", e);
    throw e; 
  }
};
const updateOilIntakeLog2 = async (id: number, payload: any): Promise<any> => {
  try {
    const response = await api.put(`${ApiConstant.updateOilIntakeLog2}/${id}`, payload);
    return response?.data;
  } catch (e) {
    console.error("Error in addOilIntakeLog:", e);
    throw e; 
  }
};
const addOilIntakeLog1 = async (payload: any): Promise<any> => {
  try {
    const response = await api.post(ApiConstant.addOilIntakeLog1, payload);
    return response?.data;
  } catch (e) {
    console.error("Error in addOilIntakeLog:", e);
    throw e; 
  }
};
 
const AddOilProcessingOutputOnly = async (payload: any): Promise<any> => {
  try {
    const response = await api.post(ApiConstant.AddOilProcessingOutputOnly, payload);
    return response?.data;
  } catch (e) {
    console.error("Error in addOilIntakeLog:", e);
    throw e; 
  }
};

const GetManufacturingunitWiseRawMaterials = async (PosID: number) => {
    try {
        const Invoice = await api.get(ApiConstant.GetManufacturingunitWiseRawMaterials + PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting pos request.', error);
         });
         const response = Invoice != null ? Invoice : null;        
         return response;
    } catch (e) {
        console.log('error getting pos request');
        return [];
    } 
};

const getvendorInvoiceforOilintakeEdit = async (data: any) => {
  debugger
    try {
        const invoiceqty: any = await api
        .post(ApiConstant.getvendorInvoiceforOilintakeEdit, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error adding pos RawMaterails', error);
         });
        const response = invoiceqty != null ? invoiceqty : null;        
        return response;
    }
    catch
    {
        console.log('error adding pos RawMaterails');
        return false;
    }
}

export const getBatchTiming = async (batchId: number): Promise<{ startTime: string; endTime: string }> => {
  try {
    const response = await api.get(`${ApiConstant.getallBatches}${batchId}`);
    return response?.data;
  } catch (e) {
    console.error("Error in getBatchTiming:", e);
    throw e;
  }
};

export const getBullsAndOperatorsByDate = async (
  posId: number,
  submittedDate: string ,
  batchNumber:number
): Promise<BullsOperatorsResponse | null> => {
  try {
    const { data } = await api.post<BullsOperatorsResponse>(
      ApiConstant.getallbullsandoperatorbyposidanddate,
      {
        posId,
        submittedDate,
        batchNumber
      }
    );
    return data ?? null;
  } catch (error) {
    console.error("Error in getBullsAndOperatorsByDate:", error);
    return null;
  }
};

export const getBullsAndOperatorsByOilIntakeLogId = async (
  oilIntakeLogID: number
): Promise<BullsOperatorsResponse | null> => {
  try {
    const { data } = await api.post<BullsOperatorsResponse>(
      ApiConstant.getallbullsandoperatorbyid,
      {
        oilIntakeLogID,
      }
    );
    return data ?? null;
  } catch (error) {
    console.error("Error in getBullsAndOperatorsByOilIntakeLogId:", error);
    return null;
  }
};

const getBullStatisticsMasterDataAsync = async ():Promise<any | []> => {

    try {
      const response = await api.get(ApiConstant.getBullStatisticsMasterDataAsync);
      return response.data;
    }
    catch(ex)
    {
        console.log(ex);
        return [];
    }
}

const getBullStatisticsSummaryAsync = async (
    manufacturingUnitId: number,
    month: number,
    year: number,
    bullId:  number | null
  ): Promise<any | []> => {
    try {
      const response = await api.get(
        `${ApiConstant.getBullStatisticsSummaryAsync}?manufacturingUnitId=${manufacturingUnitId}&month=${month}&year=${year}&bullId=${bullId}`);
      return response.data ?? [];
    } catch (ex) {
      console.log(ex);
      return [];
    }
  };

const oilProductionService ={
    GetMUPlantName,
    getOilSeedNames,
    getBullsAndOperators,
    addOilIntakeLog,
    getAllOilIntakeLogs,
    addOilIntakeLog1,
    GetMUPlantName1,
    GetMUPlantNameById,
    updateOilIntakeLog,
    updateOilIntakeLog1,
    updateOilIntakeLog2,
    getAllOilIntakeLogs1,
    AddOilProcessingOutputOnly,
    getAllOilIntakeLog,
    getAllOilSeedNames,
    getSeedOilByMonth,
    getVendorsByOilseed,
    editOilIntakeLog,
    GetManufacturingunitWiseRawMaterials,
    getvendorInvoiceforOilintakeEdit,
    getBatchTiming,
    getBullsAndOperatorsByDate,
    getBullsAndOperatorsByOilIntakeLogId,
    getBullStatisticsMasterDataAsync,
    getBullStatisticsSummaryAsync,
}
 
export default oilProductionService;
 
 
 